'use client';

import React from 'react';
import { usePathname } from 'next/navigation';
import { useDashboard } from 'src/context/providers/DashboardProvider';
import Link from 'next/link';
import { SettingsBreadcrumbs } from 'src/components/Settings/components';
import {
  AddEditCompanyDialog,
  AddUserDialog,
  DeactivateCompanyDialog,
  DeactivateDialog,
  AddDemoEnvironment,
} from './Companies';
import { useSettingsRoutes } from 'src/hooks/settings';

const SettingsLayout = ({ children }: { children: React.ReactNode }) => {
  const pathname = usePathname();

  const {
    showAddEditUserModal,
    setShowAddEditUserModal,
    showConfirmDeleteModal,
    setShowConfirmDeleteModal,
    showAddEditCompanyModal,
    setShowAddEditCompanyModal,
    showAddDemoEnvModal,
    setshowAddDemoEnvModal,
    showDeactivateCompanyModal,
    setShowDeactivateCompanyModal,
  } = useDashboard();

  const { routes } = useSettingsRoutes();

  return (
    <div className="flex flex-col gap-2 h-full w-full bg-white rounded-l-xl overflow-hidden overflow-y-auto">
      <div className="sticky top-0 right-0 z-50 flex flex-col bg-white">
        <div className="pt-4 w-full border-b border-neutral-200">
          <div className="flex flex-col gap-4 px-4 w-full">
            <div className="flex flex-col justify-center gap-1">
              <h1 className="text-2xl font-bold">Settings</h1>
              <p className="text-sm text-gray-500">
                Manage your account settings and preferences.
              </p>
            </div>
            <div className="flex gap-4">
              {routes.map((item) => {
                const isActive = item.isActive(pathname);

                return (
                  <Link
                    key={item.id}
                    href={item.path}
                    className={`relative cursor-pointer h-14 w-20 xl:w-24 flex items-center gap-2 justify-center text-sm font-normal transition-colors duration-300 ${
                      isActive
                        ? 'text-sky-600 text-base font-bold'
                        : 'text-neutral-500 hover:text-sky-600'
                    }`}
                  >
                    {isActive && (
                      <div className="absolute inset-x-0 bottom-0 h-1 bg-sky-600 rounded-t-md" />
                    )}
                    <span className="text-sm font-medium">{item.label}</span>
                  </Link>
                );
              })}
            </div>
          </div>
        </div>
        <SettingsBreadcrumbs />
      </div>
      <div className="flex flex-col gap-4 px-4 py-2 flex-1 w-full bg-white ">
        {children}
      </div>
      <AddEditCompanyDialog
        open={showAddEditCompanyModal}
        onClose={() => setShowAddEditCompanyModal(false)}
      />
      <AddDemoEnvironment
        open={showAddDemoEnvModal}
        onClose={() => setshowAddDemoEnvModal(false)}
      />
      <AddUserDialog
        open={showAddEditUserModal}
        onClose={() => setShowAddEditUserModal(false)}
      />
      <DeactivateDialog
        open={showConfirmDeleteModal}
        onClose={() => setShowConfirmDeleteModal(false)}
      />
      <DeactivateCompanyDialog
        open={showDeactivateCompanyModal}
        onClose={() => setShowDeactivateCompanyModal(false)}
      />
    </div>
  );
};

export default SettingsLayout;
